import { render, staticRenderFns } from "./pureCheckBox.vue?vue&type=template&id=5aa195d8&"
import script from "./pureCheckBox.vue?vue&type=script&lang=js&"
export * from "./pureCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports